































import Toolbar from '@/components/Toolbar.vue';
import { SurveyTemplateFileService } from '@/surveyTemplates/SurveyTemplateFileService';
import { Component, Inject, Vue } from 'vue-property-decorator';

@Component({
  components: {
    Toolbar,
  },
})
export default class SurveyTemplateUpload extends Vue {
  @Inject('surveyTemplateFileService')
  private surveyTemplateFileService!: SurveyTemplateFileService;
  private file: File | null = null;
  private uploading = false;
  private templateName = '';

  private async uploadSurveyTemplate() {
    this.uploading = true;
    await this.surveyTemplateFileService.upload(this.file, this.templateName);
    this.uploading = false;
    this.file = null;
    this.templateName = '';
  }
}
